export const LIST_MESSAGE_STATUS_REQUEST = 'LIST_MESSAGE_STATUS_REQUEST'
export const LIST_MESSAGE_STATUS_SUCCESS = 'LIST_MESSAGE_STATUS_SUCCESS'
export const LIST_MESSAGE_STATUS_FAIL = 'LIST_MESSAGE_STATUS_FAIL'

export const LIST_PRODUCT_REQUEST = 'LIST_PRODUCT_REQUEST'
export const LIST_PRODUCT_SUCCESS = 'LIST_PRODUCT_SUCCESS'
export const LIST_PRODUCT_FAIL = 'LIST_PRODUCT_FAIL'

export const LIST_PRODUCT_SUMMARY_REQUEST = 'LIST_PRODUCT_SUMMARY_REQUEST'
export const LIST_PRODUCT_SUMMARY_SUCCESS = 'LIST_PRODUCT_SUMMARY_SUCCESS'
export const LIST_PRODUCT_SUMMARY_FAIL = 'LIST_PRODUCT_SUMMARY_FAIL'

export const LIST_PAYMENT_OPTION_REQUEST = 'LIST_PAYMENT_OPTION_REQUEST'
export const LIST_PAYMENT_OPTION_SUCCESS = 'LIST_PAYMENT_OPTION_SUCCESS'
export const LIST_PAYMENT_OPTION_FAIL = 'LIST_PAYMENT_OPTION_FAIL'